import styled, { css } from 'styled-components';

export type TextSize = 'big' | 'medium' | 'standard' | 'small';

type WrapperProps = {
  $size: TextSize;
};
export const Wrapper = styled.span<WrapperProps>`
  ${({ $size }) => {
    switch ($size) {
      case 'big': {
        return css`
          font-size: 2.5rem;
        `;
      }
      case 'medium': {
        return css`
          font-size: 1.5rem;
        `;
      }
      case 'standard': {
        return css`
          font-size: 1.125rem;
        `;
      }
      case 'small': {
        return css`
          font-size: 0.875rem;
        `;
      }
      default: {
        return css`
          font-size: 1rem;
        `;
      }
    }
  }};

  a {
    color: ${({ theme }) => theme.colours.fg};
    text-decoration: underline 0.1rem rgba(0, 0, 0, 0);
    text-underline-offset: 0.1em;
    transition:
      text-decoration-color 150ms,
      text-underline-offset 150ms,
      color 150ms;
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.colours.accent};
      text-decoration-color: ${({ theme }) => theme.colours.accent};
      text-underline-offset: 0.3em;
    }

    @media (hover: none) {
      text-decoration: underline 0.1rem ${({ theme }) => theme.colours.accent};
    }
  }
`;
